module.exports = __webpack_public_path__ + "static/media/TrendSans-Five-Regular.84a0fa14.otf";


//////////////////
// WEBPACK FOOTER
// ./src/assets/fonts/TrendSans-Five-Regular.otf
// module id = 3469
// module chunks = 51